import React from 'react';

export const About = () => (
  <div className="page">
    <h2>About page</h2>
  </div>
);

export default About;



/** WEBPACK FOOTER **
 ** ./src/views/About/About.js
 **/